import $ from 'jquery';


const breakpoint = 950;
const body = $('body');
const video_element = $('#main_video_banner');

/**
 * Load in the video from the data-src attribute
 *
 * @method load_videos
 * @param HTMLElement element - HTML video tag to attach to.
 */
const load_videos = element => {
  $(element).find('source').each(() => {
    element.get(0).play();
    $(video_element).addClass('played');
    $(video_element).parent().addClass('has-video');
  });
};

/**
 * If the viewport is below our breakpoint then we will not load the
 * videos
 */
if( body.width() >= breakpoint && !video_element.hasClass('played') ) {
  load_videos(video_element);
}

/**
 * When the view port is resized we will redetermin if the videos need
 * to be loaded.
 */
$(window).resize(() => {
  if( body.width() >= breakpoint && !video_element.hasClass('played') ) {
    load_videos(video_element);
  }
});
